import client from './client';
// 사용자 퀴즈 등록 이후
export const getOwnProducts = () => {
    return client.get(
        `/shampoo/own-products`,
    )
}

